<template>
	<router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  components: {
  
  }
}
</script>

<style>
html{
	margin: 0;
	padding: 0;
}
body{
	margin: 0;
	padding: 0;
}
</style>
